import { render } from "./EditEmployeeReportTo.vue?vue&type=template&id=7dfa4dc4"
import script from "./EditEmployeeReportTo.vue?vue&type=script&lang=js"
export * from "./EditEmployeeReportTo.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__